import gql from 'graphql-tag';

export const VIEWER_LOCALE = gql`
  query getViewerLocale {
    viewer {
      id
      locale
    }
  }
`;

export const ACCOUNT_LIST = gql`
  query getViewerAccounts($first: Int, $cursor: String) {
    viewer {
      id
      accounts(first: $first, after: $cursor) {
        edges {
          role
          scopes
          node {
            id
            displayName
            type
            isHeadOfFamily
            isUnlimited
            superMatches {
              id
            }
            subscriptionInformation {
              payedBy
              ownerOfPayingAccount
              hasTrialPeriod
              hasActiveSubscription
              hasNoPreviousSubscription
            }
            gpiRepresentativeData {
              parentAccountOwnerFullName
              parentAccountOwnerEmail
            }
            brandingInformation {
              primaryColor
              logo {
                url
                width
                height
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;
